import { Lock } from '@mui/icons-material'
import { Container, ProgressBar } from 'react-bootstrap'

import { currencyFormat } from '@/utils/Currency'
import { getCalculatedStepByCoverType } from '@/utils/StepCalculate'
import {
  commercialCombinedFormStore,
  isBackofficeStore,
} from '@/store/CommercialCombinedFormStore'
import CG_Logo from '@/assets/images/cg_logo.png'

import { BackOfficeRibbon } from './BakcofficeRibbon'
import { BrokerRibbon } from './BrokerRibbon'

const Header = () => {
  const { formData, step, quotes } = commercialCombinedFormStore()
  const calculatedTotalSteps = formData?.step2?.insuranceCover === 'CC' ? 7 : 6
  const calculatedStep = getCalculatedStepByCoverType(
    formData?.step2?.insuranceCover,
    step
  )

  // TODO Add quotes.excesses detail

  const { backoffice } = isBackofficeStore()

  return (
    <>
      <Container bsPrefix="container-fluid">
        <div className="d-flex align-items-center mt-3">
          <div className="logo">
            <img src={CG_Logo} alt="CG logo" />
          </div>
        </div>
      </Container>
      <div className="mt-3">
        {backoffice ? <BackOfficeRibbon /> : <BrokerRibbon />}

        <div className="mb-4">
          <ProgressBar
            now={
              calculatedStep === 0
                ? 10
                : Math.round((calculatedStep / calculatedTotalSteps) * 100)
            }
            className="mx-n3 mx-sm-0"
          />

          {calculatedStep > 0 && (
            <>
              <div className="ps-3 mt-1 small">
                Step {calculatedStep} of {calculatedTotalSteps}
              </div>

              <Container bsPrefix="container container-body-sm">
                <div className="mt-2 rounded-5 bg-primary text-white">
                  {formData?.step2?.selectedCoverName && (
                    <div className="d-flex align-items-center">
                      <div className="d-flex flex-fill justify-content-center align-items-center px-3">
                        <Lock sx={{ fontSize: 14 }} className="me-2" />
                        <small className="fw-medium">
                          {formData?.step2?.selectedCoverName}
                        </small>
                      </div>
                      <div
                        className="d-flex flex-fill justify-content-center align-items-center px-3"
                        style={{ borderLeft: '1px dashed' }}
                      >
                        {quotes?.refer && <span>Referral</span>}
                        {!quotes?.refer && quotes?.quotePrice == null && (
                          <span>Loading...</span>
                        )}
                        {!quotes?.refer && quotes?.quotePrice != null && (
                          <>
                            <span className="fw-medium">
                              {currencyFormat(quotes?.quotePrice)}/
                            </span>
                            <small>year</small>
                          </>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </Container>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default Header
